import React, { useEffect, useRef } from 'react';

const WiresBackground = () => {
  const canvasRef = useRef(null);
  const timeRef = useRef(0);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationId;

    // Set canvas size
    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };


    // Animation loop
    const animate = () => {
      // Clear 
      ctx.fillStyle = '#fafafa';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      timeRef.current += 0.008; // A tad faster
      const time = timeRef.current;
      const centerX = canvas.width / 2;

      // Five strands with varying speeds and amplitudes
      const strands = [
        { phase: 0, amplitude: 200, speed: 0.5, twistFreq: 0.003, waveSpeed: 0.25 },
        { phase: Math.PI * 2 / 5, amplitude: 160, speed: 0.4, twistFreq: 0.0025, waveSpeed: 0.2 },
        { phase: Math.PI * 4 / 5, amplitude: 180, speed: 0.55, twistFreq: 0.0035, waveSpeed: 0.28 },
        { phase: Math.PI * 6 / 5, amplitude: 140, speed: 0.45, twistFreq: 0.0028, waveSpeed: 0.22 },
        { phase: Math.PI * 8 / 5, amplitude: 170, speed: 0.48, twistFreq: 0.0032, waveSpeed: 0.24 },
      ];

      strands.forEach((strand, strandIndex) => {
        ctx.beginPath();
        
        const points = [];
        const startY = -100;
        const endY = canvas.height + 100;
        const step = 4;
        
        for (let y = startY; y <= endY; y += step) {
          // The key: use (y - time * speed) so the wave pattern scrolls top to bottom
          const scrolledY = y - time * strand.speed * 50;
          
          // Curved swirl based on scrolled position
          const twist = scrolledY * strand.twistFreq + time * strand.waveSpeed + strand.phase;
          
          // Primary curve
          const swirlX = Math.sin(twist * 2.5) * strand.amplitude;
          
          // Secondary curve
          const curve2 = Math.sin(twist * 4 + strandIndex) * 35;
          
          // Third harmonic
          const curve3 = Math.sin(twist * 6 + time * 0.2) * 20;
          
          // Strands interact
          const interaction = Math.sin(twist * 1.5 + Math.PI / 3) * 25;
          
          const x = centerX + swirlX + curve2 + curve3 + interaction;
          
          points.push({ x, y });
        }
        
        // Draw smooth curve
        if (points.length > 1) {
          ctx.moveTo(points[0].x, points[0].y);
          
          for (let i = 1; i < points.length - 1; i++) {
            const xc = (points[i].x + points[i + 1].x) / 2;
            const yc = (points[i].y + points[i + 1].y) / 2;
            ctx.quadraticCurveTo(points[i].x, points[i].y, xc, yc);
          }
          
          const last = points[points.length - 1];
          ctx.lineTo(last.x, last.y);
        }
        
        ctx.strokeStyle = 'rgba(0, 0, 0, 0.2)';
        ctx.lineWidth = 2;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.stroke();
      });

      animationId = requestAnimationFrame(animate);
    };

    // Initialize
    resize();
    window.addEventListener('resize', resize);
    animate();

    // Cleanup
    return () => {
      window.removeEventListener('resize', resize);
      cancelAnimationFrame(animationId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: -1
      }}
    />
  );
};

export default WiresBackground;
